import { render, staticRenderFns } from "./DataAnggotaParent.vue?vue&type=template&id=5705700c&scoped=true&"
import script from "./DataAnggotaParent.vue?vue&type=script&lang=js&"
export * from "./DataAnggotaParent.vue?vue&type=script&lang=js&"
import style0 from "./DataAnggotaParent.vue?vue&type=style&index=0&id=5705700c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705700c",
  null
  
)

export default component.exports